import {
  ProductAttribute,
  ProductAttributesCard,
  TCollectionFormatted,
} from '@/types/collection'
import { PRICE_FILTER } from '../_components/filter-bar/constants'

export type FilterRecord = Record<string, string | string[] | undefined>

export interface FilterTag {
  parentKey: string
  title: string
  key: string
}

export const formatSelectedFilters = (
  selectedFilter: FilterRecord,
  attributes: ProductAttribute[] | ProductAttributesCard[]
): FilterTag[] => {
  const result: FilterTag[] = []

  Object.entries(selectedFilter).forEach(([parentKey, values]) => {
    const attribute = attributes.find((attr) => attr.seo_alias === parentKey)
    if (!attribute) return

    const valueArray = Array.isArray(values) ? values : [values]

    valueArray.forEach((val) => {
      const item = attribute.items.find((i) => i.seo_alias === val)
      if (!item) return

      result.push({
        parentKey,
        title: item.title,
        key: item.seo_alias,
      })
    })
  })

  return result
}

export const applyFilter = (
  filters: FilterRecord,
  item: FilterTag
): FilterRecord => {
  const { parentKey, key } = item
  const current = filters[parentKey]

  if (current === undefined) return { ...filters }

  const next = { ...filters }

  if (typeof current === 'string') {
    if (current.toLocaleLowerCase() === key.toLocaleLowerCase()) {
      delete next[parentKey]
    }
    return next
  }

  if (Array.isArray(current)) {
    const filtered = current.filter(
      (k) => k.toLocaleLowerCase() !== key.toLocaleLowerCase()
    )
    if (filtered.length === 0) {
      delete next[parentKey]
    } else {
      next[parentKey] = filtered
    }
  }
  console.log('next', next)
  return next
}

export const objectToSearchParams = (obj: FilterRecord): URLSearchParams => {
  const searchParams = new URLSearchParams()

  Object.entries(obj).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return

    if (Array.isArray(value)) {
      if (value.length > 0) {
        searchParams.append(key, value.join(','))
      }
    } else {
      searchParams.append(key, value)
    }
  })

  return searchParams
}

export const getFilterTags = (
  filter: FilterRecord,
  collection: TCollectionFormatted
): FilterTag[] => {
  if (!collection?.variantInfo) return []

  const {
    filter: { normalAttributes = [], attributeCards = [] },
    variantInfo: { sizeList = {}, colorMapperList = [] },
  } = collection

  const tagsNormalAttributes = formatSelectedFilters(filter, normalAttributes)
  const tagsAttributeCards = formatSelectedFilters(filter, attributeCards)

  const tagsSizeList = Object.keys(sizeList)
    .filter((key) =>
      typeof filter.size === 'string'
        ? filter.size?.toLocaleLowerCase() === key.toLocaleLowerCase()
        : filter.size?.includes(key.toLocaleLowerCase())
    )
    .map((key) => ({
      title: key,
      key: key.toLocaleLowerCase(),
      parentKey: 'size',
    }))

  const selectedUnderwear = collection.filter?.underwearList?.find(
    (item) => item.key === filter['kieu-dang-quan-lot']
  )

  const colorMapped = colorMapperList.find(
    (color) => color.seo_alias === filter.color
  )

  const prices = PRICE_FILTER.filter((price) =>
    typeof filter.price_range === 'string'
      ? filter.price_range?.toLocaleLowerCase() === price.value
      : filter.price_range?.includes(price.value)
  ).map((price) => ({
    title: price.label,
    key: price.value.toLocaleLowerCase(),
    parentKey: 'price_range',
  }))

  return [
    ...tagsAttributeCards,
    ...tagsSizeList,
    colorMapped && {
      title: colorMapped?.color_name,
      key: colorMapped?.seo_alias.toUpperCase(),
      parentKey: 'color',
    },
    ...tagsNormalAttributes,
    ...prices,
    selectedUnderwear && {
      title: selectedUnderwear.title,
      key: selectedUnderwear.key,
      parentKey: 'kieu-dang-quan-lot',
    },
  ].filter(Boolean) as FilterTag[]
}
